"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var _UsageTracker = require("MeetingsLib/tracking/UsageTracker");

var _default = function _default() {
  return function (next) {
    return function (action) {
      next(action);

      switch (action.type) {
        case ActionTypes.LOG_MEETING_CREATE:
          {
            // Fire google tag manager event manually on successful meeting booked
            // do not remove, marketing ops is using this event to track pqls
            try {
              var gtmMeetingBookedEvent = {
                event: 'MeetingBookedEvent',
                MeetingBookedText: 'Meeting Booked'
              };

              if (window.dataLayer && window.google_tag_manager) {
                window.dataLayer.push(gtmMeetingBookedEvent);
              }
            } catch (e) {
              window.Raven.captureBreadcrumb({
                message: "unable to log meeting booked via datalayer"
              });
            }

            break;
          }

        case ActionTypes.SET_EVENT_DATE:
          if (action.date) {
            (0, _UsageTracker.track)('meetingsLibSetProperty', {
              property: 'event date',
              value: action.date
            });
          }

          break;

        case ActionTypes.SET_EVENT_DATE_TIME:
          if (action.dateTime) {
            (0, _UsageTracker.track)('meetingsLibSetProperty', {
              property: 'event datetime',
              value: "" + action.dateTime
            });
          }

          break;

        case ActionTypes.SET_EVENT_DURATION:
          (0, _UsageTracker.track)('meetingsLibSetProperty', {
            property: 'event duration',
            value: "" + action.duration
          });
          break;

        case ActionTypes.SET_TIMEZONE:
          (0, _UsageTracker.track)('meetingsLibSetProperty', {
            property: 'timezone',
            value: action.timezone
          });
          break;

        case ActionTypes.TOGGLE_TROUBLESHOOT_MODE:
          (0, _UsageTracker.track)('meetingsLibTroubleshoot', {
            action: action.active ? 'enter' : 'exit'
          });
          break;

        default:
      }
    };
  };
};

exports.default = _default;
module.exports = exports.default;